import { Button, Checkbox, Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";
export default function SingleAlgoList({
  title,
  algoList,
  checkdAlgo,
  onCheckAlgo,
  index,
}) {
  return (
    <div
      style={{
        flex: "1",
        borderLeft: `${index !== 0 && "1px solid rgb(225, 225, 225)"}`,
        paddingLeft: `${index !== 0 && "16px"}`,
        paddingRight: "16px",
      }}
    >
      <div>{title}</div>
      <div style={{ marginTop: "8px" }}>
        <Input
          style={{ height: "54px" }}
          className="buttonInside disabled"
          placeholder="Enter new algo"
          addonAfter={<PlusOutlined />}
        />
      </div>
      <div>
        <Button
          type="link"
          style={{ paddingLeft: "0px" }}
          onClick={() => {
            let allChecked = true;
            algoList.forEach((algo) => {
              const match = checkdAlgo.find((item) => item.name === algo.name);
              if (match === undefined) {
                allChecked = false;
              }
            });
            algoList.forEach((algo) => {
              onCheckAlgo(algo, !allChecked);
            });
          }}
        >
          select all
        </Button>
      </div>
      <div style={{ display: "flex", flexDirection: "column" }}>
        {algoList.map((algo) => {
          const match = checkdAlgo.find((item) => item.name === algo.name);
          return (
            <Checkbox
              key={algo.name}
              checked={!!match}
              onChange={(e) => onCheckAlgo(algo, e.target.checked)}
              style={{ marginTop: "8px" }}
            >
              {algo.display}
            </Checkbox>
          );
        })}
      </div>
    </div>
  );
}
